<div class="tailoredSolutionWrap" >
    <div class="maxContainerWidth">
        <div class="contentWrap">
            <h4 class="text-gradient"> Features </h4>
            <h2>State of the Art Logistics Solution</h2>
        </div>
        <div class="solutionWrap flex justify-between flex-wrap md:flex-nowrap">
            <div *ngFor="let feature of features" class="solution">
                <img class="h-[40px] w-[40px] my-8" [src]="feature.icon">
                <h4>{{feature.title}}</h4>
                <p>{{feature.description}}</p>
            </div>
        </div>
    </div>
</div>